(() => {
  const modal = document.querySelector('[data-fit-quick-modal]');
  if (!modal) return;

  const form = modal.querySelector('[data-fit-quick-form]');
  const widthInput = modal.querySelector('[data-fit-quick-width]');
  const heightInput = modal.querySelector('[data-fit-quick-height]');
  const error = modal.querySelector('[data-fit-quick-error]');
  const fitPath = '/pages/find-your-fit';
  let trigger = null;
  let requestedType = '';

  const isFitDestination = (anchor) => {
    try {
      const url = new URL(anchor.href, window.location.origin);
      return url.origin === window.location.origin && url.pathname.replace(/\/$/, '') === fitPath;
    } catch (_) {
      return false;
    }
  };

  const open = (anchor) => {
    trigger = anchor;
    requestedType = anchor.dataset.fitType || '';
    modal.hidden = false;
    document.body.classList.add('fit-quick-modal-open');
    error.hidden = true;
    window.requestAnimationFrame(() => widthInput.focus());
  };

  const close = () => {
    modal.hidden = true;
    document.body.classList.remove('fit-quick-modal-open');
    trigger?.focus();
  };

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a[href]');
    if (!anchor || anchor.hasAttribute('data-fit-guide-direct') || !isFitDestination(anchor) || window.location.pathname.replace(/\/$/, '') === fitPath) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || anchor.target === '_blank') return;
    event.preventDefault();
    open(anchor);
  });

  modal.querySelectorAll('[data-fit-modal-close]').forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => {
    if (!modal.hidden && event.key === 'Escape') close();
  });

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (!widthInput.checkValidity() || !heightInput.checkValidity()) {
      error.textContent = 'Enter a width from 100–170 mm and a height from 30–70 mm.';
      error.hidden = false;
      return;
    }
    const url = new URL(fitPath, window.location.origin);
    url.searchParams.set('width', widthInput.value);
    url.searchParams.set('height', heightInput.value);
    if (requestedType) url.searchParams.set('type', requestedType);
    else if (window.location.pathname.includes('/collections/clip-on')) url.searchParams.set('type', 'clip-on');
    else if (window.location.pathname.includes('/collections/fit-over')) url.searchParams.set('type', 'fit-over');
    url.hash = 'fit-results';
    window.location.assign(url.toString());
  });
})();
